/**
 * @desc pms-获取供应商信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierInfoRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/getSupplierInfo/pageList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
